import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Seo } from "@/components/Seo";

export const FAQ_ITEMS = [
  { q: "What age are the worksheets for?", a: "Our worksheets and workbooks are designed for children aged 3 to 6 — preschool, nursery, LKG and UKG learners." },
  { q: "Are these digital products?", a: "Yes. Every product is a printable PDF digital download. No physical item will be shipped." },
  { q: "How do I receive my PDF?", a: "After successful payment on our secure checkout, your PDF is delivered automatically — you receive it by email right away." },
  { q: "Can I print the worksheets?", a: "Yes! You can print them at home or at a print shop, as many times as you like for your own use." },
  { q: "Can I use them at home?", a: "Absolutely — they are made for home learning, homeschooling and playful practice with parents." },
  { q: "Can teachers use them in classrooms?", a: "Yes, teachers may use our worksheets in their own classroom with their students." },
  { q: "What happens after payment?", a: "Payment is completed on our secure checkout page. Once it succeeds, your PDF workbook is delivered automatically to your email." },
];

export default function Faq() {
  return (
    <div data-testid="faq-page" className="mx-auto max-w-3xl px-6 py-16">
      <Seo
        title="FAQ | Divine Kids Learning"
        description="Answers about our printable preschool worksheets: ages, digital delivery, printing, classroom use and what happens after payment."
      />
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
        <p className="font-display text-sm font-bold uppercase tracking-[0.3em] text-brand-blue">Help Center</p>
        <h1 className="mt-3 font-display text-4xl font-black tracking-tight text-slate-800 sm:text-5xl">
          Frequently asked questions
        </h1>
        <p className="mt-4 text-lg font-semibold text-slate-500">
          Everything parents and teachers ask us about our printable worksheets.
        </p>
      </motion.div>
      <Accordion type="single" collapsible className="mt-10 space-y-3" data-testid="faq-accordion">
        {FAQ_ITEMS.map((f, i) => (
          <AccordionItem key={i} value={`faq-${i}`} className="rounded-2xl border-0 bg-white px-6 shadow-md shadow-blue-900/5">
            <AccordionTrigger data-testid={`faq-question-${i}`} className="text-left font-display text-lg font-bold text-slate-700 hover:no-underline">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-base font-semibold leading-relaxed text-slate-500">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
